module.exports = __webpack_public_path__ + "media/src/images/temp/iversity-buchmesse-hintergrund-image-a2f06913c5b4734af75a615745a3f39b.jpg";